import { useState, useEffect } from 'react'
export default function Footer() {
    return (
        <div className="block overflow-hidden w-full">
            Footer
        </div>
    )
}